module.exports = __webpack_public_path__ + "static/media/VideoJS.46ac6629.eot";


//////////////////
// WEBPACK FOOTER
// ./~/video.js/dist/font/VideoJS.eot
// module id = 1719
// module chunks = 1